<template functional>
  <span
    v-if="props.outcome.id > 0"
    v-on:click.prevent="props.processOdd($event, props)"
    :id="`mod-${props.match.matchId}-${props.outcome.id}`"
    v-bind:class="[
      'bto-sb-event-odd',
      `mod-${props.match.matchId}-${props.outcome.id}`,
      {
        'bto-sb-odd-lock':
          props.outcome.outcome === '--' ||
          props.outcome.active === false ||
          props.match.isBetStop ||
          props.checkSuspended(props),
        'bto-sb-event-odd-active': props.isOddSelected(props) && !props.match.isBetStop,
        [props.updateClasses[`class-${props.outcome.upDownClass}`]]: true,
        'bto-sb-event-odd-x': props.outcome.column === 2 && props.marketInf.on.length === 3,
      },
      props.quickBetClasses(props)
    ]">
    <span
      v-if="props.getQuickBetNotification(props) && props.getQuickBetNotification(props).betslip.status === 4"
      class="bto-sb-spinner-v1"></span>
    <Fragment v-if="!props.expandedView">
      {{ props.formatOutcome(props.outcome.originalDecimalOutcome) }}
    </Fragment>
    <Fragment v-else>
      <logo-component v-if="props.showTeamIcon && props.teamLogo(props) !== false" v-slot="{ url, reset, onLoad, loaded }" :logo-url="props.teamLogo(props).url" >
        <span class="bto-sb-event-team-logo" v-if="url" v-show="loaded">
          <img :src="url" alt="" @error="reset" @load="onLoad" />
        </span>
      </logo-component>
      <i>{{ props.expandedOutTxt(props) }}</i>
      <i>{{ props.formatOutcome(props.outcome.originalDecimalOutcome) }}</i>
    </Fragment>
  </span>
</template>

<script>
  import { toggleItem,toggleAlgoItem, placeQuickBet, getQuickbetPlacementMessage } from '@bto-services/betslip-core';
  import { showBetslipValidation } from '@bto-services/modal';
  import { mapMatchToBetslipItem, mapMatchToBetslipMatchItem, getQuickBetClass } from 'bto-models/betslip';

  export default {
    name: 'MatchOdd',
    props: {
      isOddSelected: {
        type: Function,
        default: () => {
        }
      },
      match: {
        type: Object,
        default: () => {
        },
      },
      outcome: {
        type: Object,
        default: () => ({ upDownClass: 0 }),
      },
      odd: {
        type: Object,
        default: () => {
        },
      },
      totalMatchOutcomes: {
        type: Number,
        default: 0,
      },
      expandedView: {
        type: Boolean,
        default: false
      },
      showTeamIcon: {
        type: Boolean,
        default: false
      },
      marketInf: {
        type: Object,
        default: () => {
        }
      },
      t: {
        type: Function,
        default: (n) => n
      },
      isThreeWay: {
        type: Boolean,
        required: true
      },
      expandedOutTxt: {
        type: Function,
        default: (props) => {
          const isRealThreeWay = props.marketInf.on.length === 3 && props.isThreeWay;
          if (props.outcome.column === 1) {
            return props.match.homeTeam;
          } else if (props.outcome.column === 2 && isRealThreeWay) {
            // for over/under market when sport is three way second column is not X
            // as over/under has only 2 outcomes not 3
            // so we have to fix this with isRealThreeWay const by including check for real market outcomes length
            // only if sport is three way and market has 3 columns only then we will have Draw column
            return props.t('W.M.X');
          }
          return props.match.guestTeam;
        }
      },
      teamLogo: {
        type: Function,
        default: (props) => {
          const isRealThreeWay = props.marketInf.on.length === 3 && props.isThreeWay;
          if (props.outcome.column === 1) {
            return {
              class: 'bto-sb-event-hometeam-logo',
              url: props.match.homeTeamIcon,
            };
          } else if (props.outcome.column === 2 && isRealThreeWay) {
            // for over/under market when sport is three way second column is not X
            // as over/under has only 2 outcomes not 3
            // so we have to fix this with isRealThreeWay const by including check for real market outcomes length
            // only if sport is three way and market has 3 columns only then we will have Draw column
            return false;
          }
          return {
            class: 'bto-sb-event-awayteam-logo',
            url: props.match.guestTeamIcon,
          };
        }
      },
      updateClasses: {
        type: Object,
        default: () => {
          return {
            'class-1': 'bto-sb-odd-up-2',
            'class--1': 'bto-sb-odd-dw-2',
            'class-0': '',
            'class-': '',
          };
        }
      },
      /**
       * Select or delete outcomes in match
       */
      processOdd: {
        type: Function,
        default: (evt, props) => {
          if (props.outcome.outcome === '--' || props.outcome.active === false || props.match.isBetStop || props.emptyOdd) {
            return;
          }
          if (props.match.suspended || props.outcome.suspended) {
            return;
          }
          let outcome = { ...props.outcome };
          if (outcome.sbv && !`${outcome.name}`.includes(outcome.sbv)) {
            outcome.name = `${outcome.name} (${outcome.sbv})`;
          }
          const betslip_item = mapMatchToBetslipItem(
            props.match,
            outcome,
            props.odd,
            false,
            false,
            false,
            true);
          const betslipMatchItem = mapMatchToBetslipMatchItem(props.match, false);
          const error = toggleAlgoItem(betslip_item, betslipMatchItem);
          showBetslipValidation(error);
          if (props.isOddSelected(props)) {
            placeQuickBet(betslip_item);
          }
        }
      },
      getQuickBetNotification: {
        type: Function,
        default: (props) => {
          return getQuickbetPlacementMessage({
            matchId: props.match.matchId,
            outcomeId: props.outcome.id,
            marketId: props.odd.marketId,
          });
        }
      },
      quickBetClasses: {
        type: Function,
        default: (props) => {
          const qbNotification = props.getQuickBetNotification(props);
          return getQuickBetClass(qbNotification);
        },
      },
      formatOutcome: {
        type: Function,
        default: (o) => o
      },
      /**
       * Check for "suspended" status, either the whole match or the outcome itself
       */
      checkSuspended: {
        type: Function,
        default: (props) => props.match.suspended || props.outcome.suspended
      }
    }
  };
</script>
